import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';

import { MarketingStoryDetailModalComponent } from '../marketing-story-detail-modal.component';

import { detailFromStoryCard } from '../shared/marketing-story-detail.model';

import { SuccessStoriesStoryCardComponent } from './success-stories-story-card.component';

import { storyCardSlug, type StoryCardModel } from './success-stories.utils';



@Component({

  selector: 'app-success-stories-grid',

  standalone: true,

  imports: [SuccessStoriesStoryCardComponent, MarketingStoryDetailModalComponent],

  changeDetection: ChangeDetectionStrategy.OnPush,

  template: `

    @if (stories.length === 0) {

      <p class="cg-ss-grid__empty">{{ emptyMessage }}</p>

    } @else {

      <div class="cg-ss-grid" role="list">

        @for (story of stories; track story.id) {

          <app-success-stories-story-card

            role="listitem"

            [story]="story"

            [cardId]="storyCardSlug(story)"

            [highlighted]="highlightSlug === storyCardSlug(story)"

            (readMore)="openDetail($event)"

          />

        }

      </div>

    }



    @if (selectedDetail(); as detail) {

      <app-marketing-story-detail-modal [detail]="detail" (closed)="closeDetail()" />

    }

  `,

})

export class SuccessStoriesGridComponent {

  readonly storyCardSlug = storyCardSlug;

  readonly selectedDetail = signal<ReturnType<typeof detailFromStoryCard> | null>(null);



  @Input() stories: StoryCardModel[] = [];

  @Input() highlightSlug = '';

  @Input() emptyMessage = 'No stories match your filters yet.';



  openDetail(story: StoryCardModel): void {

    this.selectedDetail.set(detailFromStoryCard(story));

  }



  closeDetail(): void {

    this.selectedDetail.set(null);

  }

}

